<template>
  <v-app id="app">
    <header-item />

    <v-content>
      <v-container>
        <v-row
          dense
          max-width="100"
        >
          <v-col
            cols="12"
            sm="12"
            md="12"
            align="center"
          >
            <h2>クラウドフォルダー ユーザー作成</h2>
          </v-col>
        </v-row>
        
        <v-stepper v-model="e1">
          <v-stepper-header>
            <template v-for="n in stepDef">
              <v-stepper-step
                :key="`${n.index}-step`"
                :complete="e1 > n.index"
                :step="n.index"
              >
                {{ n.title }}
              </v-stepper-step>
  
              <v-divider
                v-if="n.index !== stepDef.length"
                :key="n.index"
              />
            </template>
          </v-stepper-header>
          <v-stepper-items>
            <template v-for="n in stepDef">
              <v-stepper-content
                :key="`${n.index}-step`"
                :step="n.index"
              >
                <div v-if="n.index == 1">
                  <!-- 利用規約 -->
                  <terms-of-service
                    ref="TermsOfService"
                    :index="Number(`${n.index}`)"
                    :user-type="Number(`${userType}`)"
                    @termsOfServiceClickNext="setTermsOfServiceResult($event, termsOfServiceResult)"
                  />
                </div>
                <div v-if="n.index == 2">
                  <v-form
                    ref="userInfoInput"
                    v-model="valid"
                    lazy-validation
                    @submit.prevent
                  >
                    <v-card
                      color="lighten-1"
                      flat
                    >
                      <v-row
                        dense
                        max-width="100"
                      >
                        <!-- ユーザーID -->
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="1"
                          xl="1"
                        />
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="2"
                          xl="2"
                        >
                          <span>
                            ユーザーID<required-mark />
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="6"
                          xl="6"
                        >
                          <v-text-field
                            v-model="userId"
                            required
                            counter="48"
                            maxlength="48"
                            :rules="[v => (v && v.length>= 4) || &quot;ユーザーIDは4文字以上必須です&quot;,
                                     v => /^[a-zA-Z0-9-_.]+$/.test(v) || 'ユーザーIDは半角英数字と記号-_.のみ利用できます']"
                            hint="ユーザーIDを作成します。作成するユーザーIDを入力してください。"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="3"
                          xl="3"
                        />
                        <!-- ユーザー名 -->
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="1"
                          xl="1"
                        />
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="2"
                          xl="2"
                        >
                          <span>
                            ユーザー名<required-mark />
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="6"
                          xl="6"
                        >
                          <v-text-field
                            v-model="userName"
                            required
                            counter="12"
                            maxlength="12"
                            :rules="[v => !!v || &quot;ユーザー名は必須です&quot;]"
                            hint="ユーザー名を入力してください。ユーザー名はデータ共有先の取引先様にも表示されます。"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="3"
                          xl="3"
                        />
                        <!-- メールアドレス -->
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="1"
                          xl="1"
                        />
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="2"
                          xl="2"
                        >
                          <span>
                            メールアドレス
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="6"
                          xl="6"
                        >
                          <v-text-field
                            v-model="mailAddress"
                            required
                            disabled
                            readonly
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="3"
                          xl="3"
                        />
                        <!-- パスワード -->
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="1"
                          xl="1"
                        />
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="2"
                          xl="2"
                        >
                          <span>
                            パスワード<required-mark />
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="6"
                          xl="6"
                        >
                          <create-password-field ref="CreatePasswordField" />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="3"
                          xl="3"
                        />
                        <!-- パスワード確認 -->
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="1"
                          xl="1"
                        />
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="2"
                          xl="2"
                        >
                          <span>
                            パスワード確認<required-mark />
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="6"
                          xl="6"
                        >
                          <password-field ref="PasswordField" />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="3"
                          xl="3"
                        />
                        <!-- ワンタイムパスワード認証 -->
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="1"
                          xl="1"
                        />
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="2"
                          xl="2"
                        >
                          <span>ワンタイムパスワード認証</span>
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="6"
                          lg="3"
                          xl="3"
                        >
                          <v-checkbox
                            v-model="mfaflg"
                            :ripple="false"
                            :label="`ワンタイムパスワード認証を有効にする(スマートフォン必須)`"
                            disabled
                            readonly
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="6"
                          lg="3"
                          xl="3"
                          align="left"
                        >
                          <!-- ワンタイムパスワード認証説明画面-->
                          <mfa-description />
                        </v-col>
                        <v-col
                          cols="12"
                          xs="12"
                          sm="12"
                          md="12"
                          lg="3"
                          xl="3"
                        />
                        <!-- 登録 -->
                        <v-col
                          cols="12"
                          align="center"
                        >
                          <v-btn
                            color="primary"
                            @click="nextStepCheck(Number(`${n.index}`));"
                          >
                            登録
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-form>
                </div>
                <div v-if="n.index == 3">
                  <!-- ワンタイムパスワード認証初期設定画面-->
                  <mfa-setting
                    ref="MfaSetting"
                    :index="Number(`${n.index}`)"
                    :user-id="userId"
                    :user-pass-cf="userPassCf"
                    :mfaflg="mfaflg"
                    :mobile-flg="mobileFlg"
                    @clickNext="setMfaOnetimepass($event, mfaSettingResult)"
                  />
                </div>
                <div v-if="n.index == 4">
                  <v-card
                    color="lighten-1"
                    flat
                  >
                    <v-row
                      dense
                      max-width="100"
                    >
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <span>
                          ユーザー作成が完了しました。ログインが可能になります。
                        </span>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          color="primary"
                          @click="nextStepCheck(Number(`${n.index}`));"
                        >
                          ログイン画面へ
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </v-stepper-content>
            </template>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-content>
    <msg-dlg ref="MsgDlg" />
  </v-app>
</template>

<script>

import HeaderItem from './HeaderItem.vue'
import MsgDlg from './MsgDlg.vue';
import RequiredMark from './RequiredMark.vue';
import MfaSetting from './MfaSetting';
import TermsOfService from './TermsOfService';
import CreatePasswordField from './CreatePasswordField.vue';
import PasswordField from './PasswordField.vue';
import MfaDescription from './MfaDescription.vue';
import Amplify, {isMobile, Constant, RestApiUtil, GraphqlUtil, Mutations, Logger} from '../amplify_com.js';

export default {  
  components: {
    'header-item': HeaderItem,
    'msg-dlg': MsgDlg,
    'create-password-field': CreatePasswordField,
    'password-field': PasswordField,
    'required-mark': RequiredMark,
    'mfa-description': MfaDescription,
    'mfa-setting': MfaSetting,
    'terms-of-service': TermsOfService,
  },
  data: () => ({
    Constant :Constant, // template内で定数クラスを使用するため
    stepDef: [
      { 
        index : 1,
        title : '利用規約同意', 
        checkFunc: async function(app){
            return app.agreeflg;
        },
        okFunc: async function(app, now_index){
          // チェックOK時の処理
          app.$refs.MsgDlg.showInfo('利用規約に同意しました。');

          // 次へ
          app.nextStep (now_index + 1);
        },
      },
      { 
        index : 2,
        title : 'ユーザー情報入力', 
        checkFunc: async function(app){
          // コンポーネントからパスワード取得 リストレンダリングされているので[0]が必要
          app.userPass = app.$refs.CreatePasswordField[0].getPassword();
          app.userPassCf = app.$refs.PasswordField[0].getPassword();

          //バリデーション（validateはrulesが設定されている項目だけを囲う）
          if(!app.$refs.userInfoInput[0].validate()){
            if(!app.userId){
              app.$refs.MsgDlg.showError('ユーザーIDを入力してください');
              return false;
            }

            if(!app.userName){
              app.$refs.MsgDlg.showError('ユーザー名を入力してください');
              return false;
            }
            return false;
          }

          if(!app.mailAddress){
            app.$refs.MsgDlg.showError('メールアドレスを入力してください');
            return false;
          }

          if(!app.userPass){
            app.$refs.MsgDlg.showError('パスワードを入力してください');
            return false;
          }

          if(!app.userPassCf){
            app.$refs.MsgDlg.showError('パスワード確認を入力してください');
            return false;
          }

          if(app.userPass === app.userId){
            app.$refs.MsgDlg.showError('ユーザーIDと同じパスワードは入力不可です。');
            return false;
          }

          if(app.userPass !== app.userPassCf){
            app.$refs.MsgDlg.showError('パスワードとパスワード確認には同じパスワードを入力してください');
            return false;
          }

          return true;
        },
        okFunc: async function(app, now_index){
            app.$refs.MsgDlg.showOkCancel(null, '入力された情報でユーザーを作成します。\r\n本当によろしいですか？')
            .then(function(okCancelResult) {
              if(okCancelResult){
                // チェックOK時の処理
                Amplify.Auth.signUp({
                    'username' : app.userId,
                    'password' : app.userPassCf,
                    attributes: {
                        'email' : app.mailAddress, 
                        'custom:wp_custno' : 'dummydummy000',
                        'custom:wp_tmp_pass' : app.wpTmpPass,
                        'custom:mfa_type' : app.mfaflg ? Constant.UserMfa.On : Constant.UserMfa.Off,
                        'custom:auth_type' : String(app.userAuthType),
                        'custom:disp_name' : app.userName,
                        'custom:input_user_name' : app.userId,
                    },
                    validationData: []
                }).then(() => {
                  app.$refs.MsgDlg.showSuccess('ユーザーの登録に成功しました。');
                  // 次へ
                  if(app.mfaflg){
                    // MFA設定画面 初期化
                    app.$refs.MfaSetting[0].init();
                  }
                  app.nextStep(now_index + 1);
                }).catch(err => {
                  app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
                });
              }
            });
        },
      },
      { 
        index : 3,
        title : 'ワンタイムパスワード認証 初期設定', 
        checkFunc: async function(app){
          // mfa認証あり ワンタイムパスワード入力なし
          if(app.mfaflg && !app.mfaOnetimepass){
            app.$refs.MsgDlg.showError('ワンタイムパスワードを入力してください');
            app.$refs.MfaSetting[0].setLoadingOneTime();
            return false;
          }

          return true;
        },
        okFunc: async function(app, now_index){

          // mfa認証あり
          if(app.mfaflg ){
            await Amplify.Auth.signIn(
              {
                username : app.userId,
                password : app.userPassCf,
                validationData: {
                  input_username: app.userId,
                },
              }
            ).then(user => {
              let _user = user;
              Amplify.Auth.verifyTotpToken(
                _user,
                app.mfaOnetimepass,
              ).then(() => {
                Amplify.Auth.setPreferredMFA(
                  _user,
                  'TOTP'
                ).then(async () => {
                  app.$refs.MsgDlg.showModalSuccess('ワンタイムパスワード認証に成功しました。');
                  // ユーザー登録完了処理
                  let userComplete = false;
                  await app.addUserComplete(app).then(result_tmp => {
                    Logger.log(result_tmp);
                    userComplete = result_tmp;
                  }).catch(error => {
                    Logger.log(error);
                    userComplete = false;
                    app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(error));
                    app.$refs.MfaSetting[0].setLoadingOneTime();
                  });
                  if(userComplete){
                    // 次へ
                    app.nextStep(now_index + 1);
                    app.$refs.MfaSetting[0].setLoadingOneTime();
                  }
                }).catch(err => {
                  app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
                  app.$refs.MfaSetting[0].setLoadingOneTime();
                });
              }).catch(err => {
                app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
                app.$refs.MfaSetting[0].setLoadingOneTime();
              });
            }).catch(err => {
              app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
              app.$refs.MfaSetting[0].setLoadingOneTime();
            });
          } else {
            // ユーザー登録完了処理のためサインイン
            let result = false;
            await Amplify.Auth.signIn(
              {
                username : app.userId,
                password : app.userPassCf,
                validationData: {
                  input_username: app.userId,
                },
              }
            ).then(() => {
              result = true;
            }).catch(err => {
              result = false;
              app.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
              app.$refs.MfaSetting[0].setLoadingOneTime();
            });

            if(!result){
              app.$refs.MfaSetting[0].setLoadingOneTime();
              return;
            }

            // ユーザー登録完了処理
            let userComplete = false;
            await app.addUserComplete(app).then(result_tmp => {
              Logger.log(result_tmp);
              userComplete = result_tmp;
            }).catch(error => {
              Logger.log(error);
              userComplete = false;
              app.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
              app.$refs.MfaSetting[0].setLoadingOneTime();
            });
            // ユーザー登録完了処理
            if(userComplete){
              // 次へ
              app.nextStep(now_index + 1);
              app.$refs.MfaSetting[0].setLoadingOneTime();
            }
          }
        },
      },
      { 
        index : 4,
        title : '完了', 
        checkFunc: async function(){
          return true;
        },
        okFunc: async function(app, now_index){
          // 次へ
          app.nextStep(now_index + 1);
        },
      },
    ],
    e1: 1,
    steps: 4,
    wpTmpPass: '',
    userId: '', 
    userName: '',
    mailAddress: '',
    userPass: '',
    userPassCf: '',
    mobileFlg: isMobile.any,
    mfaflg: false,
    userAuthType: '',
    userType: '',
    agreeflg: false,
    mfaOnetimepass: '',
    valid: null,
    termsOfServiceResult: null,
    mfaSettingResult: null,
  }),
  watch: {
    steps (val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },
    vertical () {
      this.e1 = 2
      requestAnimationFrame(() => this.e1 = 1) // Workarounds
    },
    userId(val) {
      this.$refs.CreatePasswordField[0].setUserId(val);
      if(val === this.$refs.CreatePasswordField[0].getPassword()){
        this.$refs.MsgDlg.showError('ユーザーIDと同じパスワードは入力不可です。');
      }
    },
  },
  beforeCreate : function () {
    // 念のため、サインしているならサインアウト
    Amplify.Auth.currentUserPoolUser().then(() => {
        Amplify.Auth.signOut();
    }).catch(err => {
      // エラー発生しても無視
      Logger.log(err);
    });

    // キーチェック
    let _this = this;
    if(_this.$route.query.key){
      let key = _this.$route.query.key;
      // キーチェックrestAPIを実施。
      RestApiUtil.PostMailTokenAuth(key).then(mailTokenAuth => {
        // チェック
        if(!(mailTokenAuth.next_url.endsWith(key))){
          // この画面を表示する権限がないので戻る
          _this.$router.push({ path: "/" }, () => {}, () => {});
        }
        // apiから取得した初期データを画面に設定
        _this.wpTmpPass = key;
        _this.mailAddress = mailTokenAuth.mail_address;
        _this.mfaflg = mailTokenAuth.mfaflg === Constant.UserMfa.On ? true : false;
        _this.userAuthType = parseInt(mailTokenAuth.user_auth_type);
        _this.userType = parseInt(mailTokenAuth.user_type);
      }).catch(() => {
        // この画面を表示する権限がないので戻る
        _this.$router.push({ path: "/" }, () => {}, () => {});
      });
    } else {
      // この画面を表示する権限がないので戻る
      _this.$router.push({ path: "/" }, () => {}, () => {});
    }
  },
  mounted() {
    //戻るボタン無効化
    history.pushState(null, null, null);
    window.addEventListener("popstate", function () {
      history.pushState(null, null, null);
      return;
    });
  },
  methods: {
    nextStepCheck : async function(n) {
      var curDef = this.stepDef[n-1];
      if(await curDef.checkFunc(this)){
        curDef.okFunc(this, n);
      }
    },
    nextStep (n) {
      if (n === this.steps + 1) {
        // 次のステップはないのでログイン画面へ遷移
        this.$router.push({ path: "/" }, () => {}, () => {});
      } else {
        this.e1 = n
      }
    },
    // 利用規約画面からのコールバック
    setTermsOfServiceResult(termsOfServiceResult){
      this.agreeflg = termsOfServiceResult.agreeflg;
      this.nextStepCheck(termsOfServiceResult.index);
    },
    // MFA初期設定画面からのコールバック
    setMfaOnetimepass(mfaSettingResult){
      this.mfaOnetimepass = mfaSettingResult.mfaOnetimepass;
      this.nextStepCheck(mfaSettingResult.index);
    },
    addUserComplete : async function(app){
      // ユーザー登録完了APIを実行
      let _result = false;
      await GraphqlUtil.exec(Mutations.AddUserComplete, null).then(result_tmp => {
        Logger.log(result_tmp);
        _result = true;
      }).catch(error => {
        Logger.log(error);
        _result = false;
        app.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
      });

      return _result;
    },
  }
};

</script>

<style>
</style>